import { render, staticRenderFns } from "./putOnHoldConfirmModal.vue?vue&type=template&id=f4204af6&scoped=true"
import script from "./putOnHoldConfirmModal.vue?vue&type=script&lang=js"
export * from "./putOnHoldConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./putOnHoldConfirmModal.vue?vue&type=style&index=0&id=f4204af6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4204af6",
  null
  
)

export default component.exports